import React from 'react';
import { IcPin } from 'components/common/icons/EmojiIcons';

interface LocationLoadingProps {
    visible: boolean;
    message?: string;
}

export const LocationLoading: React.FC<LocationLoadingProps> = ({ visible, message }) => {
    if (!visible) return null;

    return (
        <div style={{
            position: 'fixed',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            backgroundColor: 'rgba(0,0,0,0.45)',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            zIndex: 9999,
        }}>
            <div style={{
                backgroundColor: '#fff',
                borderRadius: 16,
                padding: '28px 36px',
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                gap: 16,
                boxShadow: '0 4px 24px rgba(0,0,0,0.15)',
            }}>
                {/* GPS 아이콘 + 펄스 애니메이션 */}
                <div style={{ position: 'relative', width: 56, height: 56 }}>
                    <div style={{
                        position: 'absolute',
                        inset: 0,
                        borderRadius: '50%',
                        border: '3px solid #4A90D9',
                        animation: 'locPulse 1.5s ease-out infinite',
                    }} />
                    <div style={{
                        position: 'absolute',
                        inset: 8,
                        borderRadius: '50%',
                        border: '2px solid #4A90D9',
                        animation: 'locPulse 1.5s ease-out 0.3s infinite',
                    }} />
                    <div style={{
                        position: 'absolute',
                        top: '50%',
                        left: '50%',
                        transform: 'translate(-50%, -50%)',
                        color: '#4A90D9',
                    }}><IcPin size={24} /></div>
                </div>
                <div style={{
                    fontSize: 15,
                    fontWeight: 600,
                    color: '#333',
                    textAlign: 'center',
                    lineHeight: 1.5,
                }}>
                    {message || '현재 위치를 조회하고 있습니다...'}
                </div>
                {/* 스피너 */}
                <div style={{
                    width: 28,
                    height: 28,
                    border: '3px solid #eee',
                    borderTop: '3px solid #4A90D9',
                    borderRadius: '50%',
                    animation: 'locSpin 0.8s linear infinite',
                }} />
            </div>
            <style>{`
                @keyframes locPulse {
                    0% { transform: scale(1); opacity: 0.6; }
                    100% { transform: scale(1.6); opacity: 0; }
                }
                @keyframes locSpin {
                    to { transform: rotate(360deg); }
                }
            `}</style>
        </div>
    );
};
